// import React, { useState } from "react";
// import "./TravelersAsking.css";
// import { FaRegCommentDots } from "react-icons/fa";
// import { FiChevronRight } from "react-icons/fi";

// const TravelersAsking = ({property}) =>{
//   const [openIndex, setOpenIndex] = useState(null);

//   const questions = [
//     { q: "Do they serve breakfast?", a: "Yes, breakfast is available every morning at the property." },
//     { q: "Can I park there?", a: "Yes, free private parking is possible on site (reservation is not needed)." },
//     { q: "Is the restaurant open?", a: "The restaurant is open daily from 7:00 AM to 10:00 PM." },
//     { q: "Is there a swimming pool?", a: "Yes, the property has an outdoor swimming pool for guests." },
//     { q: "Is there a spa?", a: "Yes, guests can enjoy spa and wellness facilities at the hotel." },
//     { q: "What are the check-in and check-out times?", a: "Check-in from 2:00 PM – Check-out until 12:00 PM." },
//     { q: "What restaurants, attractions, and public transit options are nearby?", a: "Nearby are local restaurants, shopping centers, and public bus stations within walking distance." },
//     { q: "What's the pet policy?", a: "Pets are allowed on request. Charges may apply." },
//     { q: "Is there an airport shuttle service?", a: "Yes, airport shuttle service can be arranged for an additional charge." },
//     { q: "What's the Wi-Fi policy?", a: "High-speed Wi-Fi is available in all areas free of charge." },
//   ];

//   const toggleAnswer = (index) => {
//     setOpenIndex(openIndex === index ? null : index);
//   };

//   return (
//     <div className="asking-container">
//       <div className="asking-header">
//         <h2>Travelers are asking</h2>
//         <button className="availability-btn">See availability</button>
//       </div>

//       <div className="asking-grid">
//         {/* Left column */}
//         <div className="asking-box">
//           {questions.slice(0, 5).map((item, i) => (
//             <div key={i} className="asking-item" onClick={() => toggleAnswer(i)}>
//               <div className="asking-left">
//                 <FaRegCommentDots className="asking-icon" />
//                 <span className="asking-text">{item.q}</span>
//               </div>
//               <FiChevronRight className={`arrow-icon ${openIndex === i ? "rotate" : ""}`} />
//               {openIndex === i && <div className="answer-box">{item.a}</div>}
//             </div>
//           ))}
//         </div>

//         {/* Right column */}
//         <div className="asking-box">
//           {questions.slice(5).map((item, i) => {
//             const index = i + 5;
//             return (
//               <div key={index} className="asking-item" onClick={() => toggleAnswer(index)}>
//                 <div className="asking-left">
//                   <FaRegCommentDots className="asking-icon" />
//                   <span className="asking-text">{item.q}</span>
//                 </div>
//                 <FiChevronRight className={`arrow-icon ${openIndex === index ? "rotate" : ""}`} />
//                 {openIndex === index && <div className="answer-box">{item.a}</div>}
//               </div>
//             );
//           })}
//         </div>

//         {/* Ask Question Box */}
//         <div className="ask-box">
//           <h3>Still looking?</h3>
//           <button className="ask-btn">Ask a question</button>
//           <p>We have an instant answer to most questions</p>
//         </div>
//       </div>
//     </div>
//   );
// }
// export default  TravelersAsking;












// import React, { useState, useEffect } from "react";
// import "./TravelersAsking.css";
// import { FaRegCommentDots } from "react-icons/fa";
// import { FiChevronRight } from "react-icons/fi";

// const TravelersAsking = ({ property }) => {
//   const [openIndex, setOpenIndex] = useState([0, 1, 2, 3]); // 4 default open
//   const [questions, setQuestions] = useState([]);

//   // 4 default static questions
//   const defaultQuestions = [
//     {
//       q: "Do they serve breakfast?",
//       a: "Yes, breakfast is available every morning at the property.",
//     },
//     {
//       q: "Can I park there?",
//       a: "Yes, free private parking is possible on site (reservation is not needed).",
//     },
//     {
//       q: "Is the restaurant open?",
//       a: "The restaurant is open daily from 7:00 AM to 10:00 PM.",
//     },
//     {
//       q: "Is there a swimming pool?",
//       a: "Yes, the property has an outdoor swimming pool for guests.",
//     },
//   ];

//   // Fetch approved Q&A from API
//   useEffect(() => {
//     // if (property?.vendor?._id) {
//     //   fetch(
//     //     `https://striking-dedication-production.up.railway.app/api/v1/public/question?vendorId=${property.vendor._id}`,
//     //     {
//     //       method: "GET",
//     //       headers: { "Content-Type": "application/json" },
//     //     }
//     //   )
//     //     .then((res) => {
//     //       if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
//     //       return res.json();
//     //     })
//     //     .then((data) => {
//     //       const approved = data?.data?.questions?.filter(
//     //         (q) => q.status === "approved"
//     //       );
//     //       const mapped = approved.map((q) => ({
//     //         q: q.question,
//     //         a: q.answer || "Answer not available yet",
//     //         user: q.userInfo?.name || "Traveler",
//     //       }));
//     //       setQuestions(mapped);
//     //     })
//     //     .catch((err) => console.error("Fetch error:", err));
//     // }


//     const dummyApproved = [
//       {
//         q: "Is there a private outdoor space?",
//         a: "Yes, there is a balcony with a great view.",
//         user: "Ali Khan",
//       },
//       {
//         q: "What are the check-in and check-out times?",
//         a: "Check-in from 2:00 PM and check-out until 12:00 PM.",
//         user: "Fatima",
//       },
//       {
//         q: "Is Wi-Fi available?",
//         a: "Yes, free high-speed Wi-Fi is available in all rooms.",
//         user: "John Doe",
//       },
//     ];

//     setQuestions(dummyApproved);
//   }, [property]);

//   const toggleAnswer = (index) => {
//     setOpenIndex((prev) =>
//       prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
//     );
//   };

//   const combinedQuestions = [...defaultQuestions, ...questions];

//   return (
//     <div className="asking-container">
//       <div className="asking-header">
//         <h2>Travelers are asking</h2>
//         <button className="availability-btn">See availability</button>
//       </div>

//       <div className="asking-grid">
//         {/* Left column */}
//         <div className="asking-box">
//           {combinedQuestions
//             .slice(0, Math.ceil(combinedQuestions.length / 2))
//             .map((item, i) => (
//               <div
//                 key={i}
//                 className="asking-item"
//                 onClick={() => toggleAnswer(i)}
//               >
//                 <div className="asking-left">
//                   <FaRegCommentDots className="asking-icon" />
//                   <span className="asking-text">
//                     {item.q}{" "}
//                     {item.user && (
//                       <small style={{ color: "#888", fontSize: "12px" }}>
//                         – {item.user}
//                       </small>
//                     )}
//                   </span>
//                 </div>
//                 <FiChevronRight
//                   className={`arrow-icon ${
//                     openIndex.includes(i) ? "rotate" : ""
//                   }`}
//                 />
//                 {openIndex.includes(i) && (
//                   <div className="answer-box">{item.a}</div>
//                 )}
//               </div>
//             ))}
//         </div>

//         {/* Right column */}
//         <div className="asking-box">
//           {combinedQuestions
//             .slice(Math.ceil(combinedQuestions.length / 2))
//             .map((item, j) => {
//               const index = j + Math.ceil(combinedQuestions.length / 2);
//               return (
//                 <div
//                   key={index}
//                   className="asking-item"
//                   onClick={() => toggleAnswer(index)}
//                 >
//                   <div className="asking-left">
//                     <FaRegCommentDots className="asking-icon" />
//                     <span className="asking-text">
//                       {item.q}{" "}
//                      <br /> {item.user && (
//                         <small style={{ color: "#888", fontSize: "12px" }}>
//                           – {item.user}
//                         </small>
//                       )}
//                     </span>
//                   </div>
//                   <FiChevronRight
//                     className={`arrow-icon ${
//                       openIndex.includes(index) ? "rotate" : ""
//                     }`}
//                   />
//                   {openIndex.includes(index) && (
//                     <div className="answer-box">{item.a}</div>
//                   )}
//                 </div>
//               );
//             })}
//         </div>

//         {/* Ask Question Box */}
//         <div className="ask-box">
//           <h3>Still looking?</h3>
//           <button className="ask-btn">Ask a question</button>
//           <p>We have an instant answer to most questions</p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TravelersAsking;































import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import "./TravelersAsking.css";
import { FaRegCommentDots , FaCheckCircle  } from "react-icons/fa";
import { FiChevronRight } from "react-icons/fi";
import { MdChevronRight } from "react-icons/md";



import { toast } from "react-toastify";






const TravelersAsking = ({ property }) => {
  const [openIndex, setOpenIndex] = useState([0, 1, 2, 3]); // 4 default open
  const [questions, setQuestions] = useState([]);

    const [showModal, setShowModal] = useState(false);
  const [question, setQuestion] = useState("");
  const navigate = useNavigate();

  // const handleAskClick = () => {
  //   const token = localStorage.getItem("authToken");
  //   const user = localStorage.getItem("User Data");

  //   if (!token || !user) {
  //     // Not logged in
  //     toast.warn("You are not logged in. Click OK to go to login.");

  //     navigate("/login");
  //     return;
  //   }

  //   // Open modal if logged in
  //   setShowModal(true);
  // };

  // const handleSubmit = () => {
  //   const token = localStorage.getItem("authToken");
  //   const user = JSON.parse(localStorage.getItem("User Data"));

  //   if (!question.trim()) {
  //     toast.success("Please enter a question before submitting.");
  //     return;
  //   }

  //   fetch("https://striking-dedication-production.up.railway.app/api/v1/user/questions", {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: `Bearer ${token}`,
  //     },
  //     body: JSON.stringify({
  //       vendorId: property?.vendorId,
  //       propertyId  : property?._id,
  //       question,
  //     }),
  //   })
  //     .then((res) => res.json())
  //     .then((data) => {
  //       console.log("Submitted:", data);
  //       toast.success("Your question has been submitted successfully!");
  //       setShowModal(false);
  //       setQuestion("");
  //     })
  //     .catch((err) => {
  //       console.error("Error submitting question:", err);
  //       toast.success("Something went wrong. Try again.");
  //     });
  // };





  const handleAskClick = () => {
  const token = localStorage.getItem("authToken");
  const user = localStorage.getItem("User Data");

  if (!token || !user) {
    toast.warn("You are not logged in. Click OK to go to login.");

    navigate("/login");
    return;
  }

  setShowModal(true);
};

const handleSubmit = () => {
  const token = localStorage.getItem("authToken");
  const userData = localStorage.getItem("User Data");

  if (!token || !userData) {
    toast.warn("You are not logged in. Click OK to go to login.");

    navigate("/login");
    return;
  }

  let user;
  try {
    user = JSON.parse(userData);
  } catch (err) {
    console.error("Invalid User Data in localStorage:", err);
    toast.success("Your session is invalid. Please log in again.");
    navigate("/login");
    return;
  }

  if (!question.trim()) {
    toast.success("Please enter a question before submitting.");
    return;
  }

  fetch("https://striking-dedication-production.up.railway.app/api/v1/user/questions", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      vendorId: property?.vendorId,
      propertyId: property?._id,
      question,
    }),
  })
    .then((res) => res.json())
    .then((data) => {
      console.log("Submitted:", data);
      toast.success("Your question has been submitted successfully!");
      setShowModal(false);
      setQuestion("");
    })
    .catch((err) => {
      console.error("Error submitting question:", err);
      toast.success("Something went wrong. Try again.");
    });
};




  // 4 default static questions
  const defaultQuestions = [
    {
      q: "Do they serve breakfast?",
      a: "Yes, breakfast is available every morning at the property.",
    },
    {
      q: "Can I park there?",
      a: "Yes, free private parking is possible on site (reservation is not needed).",
    },
    {
      q: "Is the restaurant open?",
      a: "The restaurant is open daily from 7:00 AM to 10:00 PM.",
    },
    {
      q: "Is there a swimming pool?",
      a: "Yes, the property has an outdoor swimming pool for guests.",
    },
  ];

  // Fetch approved Q&A from API
  useEffect(() => {
    if (property?.vendorId) {
      fetch(
        `https://striking-dedication-production.up.railway.app/api/v1/public/questions`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ vendorId: property.vendorId }),

        }
      )
        .then((res) => {
          if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
          return res.json();
        })
        .then((data) => {
          console.log(data)
          const approved = data?.data?.questions?.filter(
            (q) => q.status === "approved"
          );

          const mapped = approved.map((q) => ({
            q: q.question,
            a: q.answer || "Answer not available yet",
            user: q.userInfo?.name || "Traveler",
            id: q._id,
          }));
          setQuestions(mapped);
        })
        .catch((err) => console.error("Fetch error:", err));
    }
  }, [property]);

  const toggleAnswer = (index) => {
    setOpenIndex((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const combinedQuestions = [...defaultQuestions, ...questions];

  return (
    <>
    <div className="asking-container">
      <div className="asking-header">
        <h2>Travelers are asking</h2>
        <button className="availability-btn">See availability</button>
      </div>

      <div className="asking-grid">
        {/* Left column */}
        <div className="asking-box">
          {combinedQuestions
            .slice(0, Math.ceil(combinedQuestions.length / 2))
            .map((item, i) => (
              <div
                key={item.id || i}
                className="asking-item"
                onClick={() => toggleAnswer(i)}
              >
                <div className="asking-left">
                  <FaRegCommentDots className="asking-icon" />
                  <span className="asking-text">
                    {item.q}{" "}
                    {item.user && (
                      <small style={{ color: "#888", fontSize: "12px" }}>
                        – {item.user}
                      </small>
                    )}
                  </span>
                </div>
                <FiChevronRight
                  className={`arrow-icon ${
                    openIndex.includes(i) ? "rotate" : ""
                  }`}
                />
                {openIndex.includes(i) && (
                  <div className="answer-box">    <FaCheckCircle style={{ color: "#0071c2", marginRight: "8px" }} />
 {item.a}</div>
                )}
              </div>
            ))}
        </div>

        {/* Right column */}
        <div className="asking-box">
          {combinedQuestions
            .slice(Math.ceil(combinedQuestions.length / 2))
            .map((item, j) => {
              const index = j + Math.ceil(combinedQuestions.length / 2);
              return (
                <div
                  key={item.id || index}
                  className="asking-item"
                  onClick={() => toggleAnswer(index)}
                >
                  <div className="asking-left">
                    <FaRegCommentDots className="asking-icon" />
                    <span className="asking-text">
                      {item.q}{" "}
                      {item.user && (
                        <small style={{ color: "#888", fontSize: "12px" }}>
                          – {item.user}
                        </small>
                      )}
                    </span>
                  </div>
                  <FiChevronRight
                    className={`arrow-icon ${
                      openIndex.includes(index) ? "rotate" : ""
                    }`}
                  />
                  {openIndex.includes(index) && (
                    <div className="answer-box">  <FaCheckCircle style={{ color: "#0071c2", marginRight: "8px" }} />{item.a}</div>
                  )}
                </div>
              );
            })}
        </div>

        {/* Ask Question Box */}
        <div className="ask-box">
          <h3>Still looking?</h3>
          <button className="ask-btn" onClick={handleAskClick}>Ask a question</button>
          <p>We have an instant answer to most questions</p>
        </div>
      </div>
    </div>
    {showModal && (
        <div className="modal-overlay1">
          <div className="modal-box1">
            <h3>Ask Your Question</h3>
            <p>About: Four Squares by WI Hotel</p>
            <textarea
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
              placeholder="Type your question here..."
            />
            <p style={{fontSize :"13px"}}>
If we can't answer your question right away, you can forward it to the property. Make sure not to include any personal info and to 
follow our guidelines
.</p>
            <div className="modal-actions1">
              <button className="ask-btn" onClick={handleSubmit}>
                Submit
              </button>
              <button
                className="cancel-btn1"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    {/* <AskQuestionBox /> */}
    </>
  );
};





export default TravelersAsking;
